import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import PopUpOther from './_PopUpOther';
import DataConfig from './../_config.json';
import './stylemain.css';
import { AlertPopup } from './../PopUp/AlertPopup';
import { OnGetJsoni } from '../_getjson';

const jobTypes = ['เปิด', 'ปิด'];
export default class _tab_4 extends React.Component {
    state = {
        data1: "",
        barcodeTable: [],
        rowChk_barcodetb: "",
        rowintable: "20",
        rowChk: "",
    }
    setRow = (count) => {
        var data = [];
        for (var i = 0; i <= count - 1; i++) {
            data[i] = {
                C0: i + 1,
                C1: "",
                C2: "",
                C3: "",
                C3_insert: "",
                C4: "",
            }
        }
        this.setState({ barcodeTable: data });
    }
    componentDidMount = () => {
        this.setRow(this.state.rowintable);
    }

    onRowClick = (row, col) => {
        if (col === 3) {
            this.setState({ rowChk: row['C0'] });

            setTimeout(() => {
                if (this.state.rowChk === "3") {
                    this.setState({ colChk: col });
                }
                let dataArray = this.state.barcodeTable;
                let tableRow = dataArray.length;
                let i;
                for (i = 0; i <= tableRow; i++) {
                    try {
                        dataArray[i].btn = 2;
                    } catch (error) {
                        console.log(error);
                    }
                }
                dataArray[this.state.rowChk - 1].btn = 1;

                this.setState({ barcodeTable: dataArray });
            }, 30);
        } else if (col === 3) {
            this.setState({ rowChk: row['C0'] });
            setTimeout(() => {
                let dataArray = this.state.barcodeTable;
                try {
                    dataArray[this.state.rowChk - 1].btn = 2;
                }
                catch (err) {
                    console.log(err);
                }
                dataArray[this.state.rowChk - 1].C4 = "เปิด";
                this.setState({ barcodeTable: dataArray });
            }, 30);
        } else {
            this.setState({ rowChk: row['C0'] });
            setTimeout(() => {
                let dataArray = this.state.barcodeTable;
                try {
                    dataArray[this.state.rowChk - 1].btn = 2;
                }
                catch (err) {
                    console.log(err);
                }
                this.setState({ barcodeTable: dataArray });
            }, 30);
        }

        setTimeout(() => { this.props.Getdata("databarcode", this.state); }, 50);
    }
    _afterSaveCell = (row, cellName, cellValue) => {


        if (cellValue.length > 0 && cellName === 'C3') {
            this._addData(cellValue, row, cellName);
        }
        setTimeout(() => {
            this._chkrowData(row, cellName, cellValue);
        }, 80);
        setTimeout(() => {
            this.props.Getdata("databarcode", this.state);
        }, 100);
    }
    _addData = (ItemCode, row, cellName) => {
        switch (cellName) {
            case "C3":
                var url = "CSUNIT/ByCode?code=" + ItemCode;
                let col = this.state.barcodeTable;
                OnGetJsoni(url, "load").then(data => {
                    // console.log(data);
                    var j = this.state.rowintable;
                    for (var i = this.state.barcodeTable.length - 1; i >= 0; i--) {// หาจากล่างขึ้นบน
                        if (!this.state.barcodeTable[i].C3) {
                            j = i;
                        }
                        else if (ItemCode === this.state.barcodeTable[i].C3) {
                            j = i;
                        }
                    }//หา แถวที่ว่างบนสุดใน products Table
                    if (data.length > 0) {
                        col[row.C0 - 1].C3 = "";
                        for (let i = 0; i < data.length; i++) { //เพิ่มขอมูลทั้งหมด ลง products Table 
                            // this.setState({wherehosesearch:})
                            col[j] = {
                                C0: this.state.barcodeTable[j].C0,
                                C1: this.state.barcodeTable[j].C1,
                                C2: this.state.barcodeTable[j].C2,
                                C3: data[i].MYNAMETH + ".",
                                C3_insert: data[i].CODE,
                                C4: "เปิด"
                            }
                            j++;
                        }
                    } else {
                        // col[row.C0-1].C1 =""; 
                        // col[row.C0-1].C2 =""; 
                        // col[row.C0-1].C4 =""; 
                        col[row.C0 - 1].C3_insert = "";
                        col[row.C0 - 1].C3 = "";
                        col[row.C0 - 1].C4 = ""
                        AlertPopup("Warning", "ไม่พบข้อมุล");
                        // setTimeout(() => {
                        //     this._chkrowData(row,cellName,ItemCode)
                        // }, 20);

                    }
                    this.setState({
                        tableData: col
                    });
                });
                break;
            default: break;
        }
    }

    _chkrowData = (row, cellName, cellValue) => {
        if (cellName === "C1") {
            let data_2 = this.state.barcodeTable;
            for (let index = row.C0; index <= data_2.length; index++) {
                try {
                    if (data_2[index].C1 !== "") {
                        data_2[index - 1].C1 = data_2[index].C1;
                        data_2[index - 1].C2 = data_2[index].C2;
                        data_2[index - 1].C3 = data_2[index].C3;
                        data_2[index - 1].C4 = data_2[index].C4;
                        data_2[index].C1 = "";
                        data_2[index].C2 = "";
                        data_2[index].C3 = "";
                        data_2[index].C4 = "";
                    }
                } catch (error) {
                    console.log("err=>" + error);
                }
            }
            this.setState({
                barcodeTable: data_2
            });
        }

    }

    // onClick={this.SetPopup.bind(null,"unitStockintable")}
    _cellButton = (cell, row, enumObject, rowIndex) => {
        var btn = this.state.barcodeTable[rowIndex].btn;
        var btnShow = "";
        switch (btn) {
            case 1: btnShow = <i class="fas fa-sort-down icon_down" onClick={this.SetPopup.bind(null, "unitStockintable")} ></i>; break;
            default: btnShow = <i class=""></i>; break;
        }
        return (<div>{btnShow}</div>);
    }

    //**************************************************************************popup**************************************************************************************/
    SetPopup = (data) => {
        this.setState({ PopUpTYpe: data });
        this.setState({ showPopupOT: !this.state.showPopupOT });
        //  console.log(data); 
    }
    Get_PopUpOther = (data) => {
        switch (this.state.PopUpTYpe) {

            case "unitStockintable":
                var dataArray = this.state.barcodeTable;
                dataArray[this.state.rowChk - 1].btn = 1;
                let arrData = this.state.barcodeTable;
                var j = this.state.rowintable;
                for (var i = this.state.barcodeTable.length - 1; i >= 0; i--) { // หาจากล่างขึ้นบน
                    if (!this.state.barcodeTable[i].C3) {
                        j = i;
                    } else if (dataArray.C0 === this.state.barcodeTable[i].C3) {
                        j = i;
                    }
                } //หา แถวที่ว่างบนสุดใน products Table
                try {
                    // console.log(this._spritData(data)[0]+"."); 
                    arrData[j].C3_insert = this._spritData(data)[0];
                    arrData[j].C3 = this._spritData(data)[0] + ".";
                    arrData[j].C4 = "เปิด";
                    arrData[this.state.rowChk - 1].btn = 2;
                    this.setState({ barcodeTable: arrData });
                } catch (error) {
                    console.log(error);
                }
                break;
        }
        this.setState({ showPopupOT: !this.state.showPopupOT });
        setTimeout(() => { this.props.Getdata("databarcode", this.state); }, 50);
    }
    PopUpOtherClose = (data) => {
        this.setState({ showPopupOT: !this.state.showPopupOT });
    }
    _spritData(data) {
        var str = data.split("|");
        return str;
    }
    render() {
        const cellEditProp = {
            mode: 'click',
            blurToSave: true,
            beforeSaveCell: this.onBeforeSaveCell,
            afterSaveCell: this._afterSaveCell,
            blurToSave: true,
        };
        const options = {
            onRowClick: this.onRowClick
        };
        return (
            <div class={this.props.Inventory.showResults === 3 ? '' : "InventoryHidden"}>
                <br></br>
                {this.state.showPopupOT ? <PopUpOther closePopup={this.PopUpOtherClose} Get_PopUpOther={this.Get_PopUpOther} type={this.state.PopUpTYpe} Data={this.state.valuePopup} groupdata={this.state.grouptoDB} apikeyData={DataConfig.API_KEY[localStorage.getItem("company")]} jwtData={localStorage.getItem("Token")} /> : null}

                <div class="container" align="center">
                    <BootstrapTable
                        data={this.state.barcodeTable}
                        cellEdit={cellEditProp}
                        options={options}
                        height='400'
                        headerStyle={{ borderBottom: '#BFBCBB  1px solid' }}
                    >
                        <TableHeaderColumn row="0" rowSpan="2" dataField='C0' isKey width="40" dataAlign="center"> </TableHeaderColumn>
                        <TableHeaderColumn row="0" rowSpan="2" dataField='C1' editable dataAlign="center" > รหัสบาร์โค๊ด </TableHeaderColumn>
                        <TableHeaderColumn row="0" rowSpan="2" dataField='C2' editable dataAlign="center" > ชื่อพิมพ์บาร์โค๊ด </TableHeaderColumn>
                        <TableHeaderColumn row="0" colSpan="2" editable dataAlign="center" columnClassName='colbuttomhidden'> หน่วย </TableHeaderColumn>
                        <TableHeaderColumn row="1" dataField='C3' dataAlign="center" editable > </TableHeaderColumn>
                        <TableHeaderColumn row="1" dataField='btn' dataAlign="center" width='40' editable={false} dataFormat={this._cellButton.bind(this)} columnClassName='c_btn'> </TableHeaderColumn>

                        <TableHeaderColumn row="0" rowSpan="2" dataField='C4' dataAlign="center" editable={{ type: 'select', options: { values: jobTypes } }} width="20%" > การใช้งาน </TableHeaderColumn>
                        <TableHeaderColumn dataField='C3_insert' dataAlign="center" hidden> </TableHeaderColumn>

                    </BootstrapTable>
                </div>
            </div>
        )
    }
}
